import bootstrap from '../../../bootstrap';
import Vip from '../../../../pages/vip/views/motors/motors.desktop';
import 'drift-zoom/dist/Drift.min';

bootstrap(Vip);
